export enum Segments {
    MARKET = "Markt",
    COMPANY = "Unternehmen",
    RISK = "Risiko",
    COMPLIANCE = "Compliance"

}
